// test1509
(1509 && 0);
